module.exports = __webpack_public_path__ + "img/10_82.7c974cb5.png";